window.addEventListener('scroll', () => {
    if (window.innerWidth < 1024) {
        return
    }
       
    const scrollTop = window.pageYOffset;
    const sections = document.querySelectorAll('.parallax-section');

    sections.forEach((section) => {
        const parallaxImages = section.querySelectorAll('.parallax-image');
        parallaxImages.forEach((image, index) => {
            const speed = (index + 1) * 0.07;
            const offset = scrollTop * speed;
            image.style.transform = `translateY(calc(-50% + ${offset}px))`;
        });
    });
});